import { useEffect } from 'react';
import { gtmBasicEvent } from '@klaviyo-mkt/gatsby-components/shared/utils/google-tag-manager';
import { courseRegisterEventData, registerForResource } from '@academy/utils';

import type { ILesson } from '@academy/graphql/types';
import type { IGTMEvent } from '@klaviyo-mkt/gatsby-components/shared/utils/google-tag-manager';

/**
 * Custom hook to handle registration for single-lesson courses
 *
 * @param lesson - The lesson data
 * @param isSingleLessonCourse - Whether this is a single-lesson course
 * @param loggedIn - Whether the user is logged in
 * @param resourceType - The type of resource
 */
export const useSingleLessonRegistration = (
  lesson: ILesson | null,
  isSingleLessonCourse: boolean,
  loggedIn: boolean,
  resourceType: string,
) => {
  useEffect(() => {
    // Single-lesson courses redirect straight to the lesson
    // Since we can't capture a registration on the course overview
    // we need to register users when they land here
    if (lesson && isSingleLessonCourse && lesson?.course?.registrationUrl && loggedIn) {
      const { thirdPartyId: resourceId, registrationUrl, title: resourceName } = lesson.course;
      const eventData: IGTMEvent = courseRegisterEventData({
        resourceName,
        resourceCategory: resourceType,
        non_interaction_flag: true,
      });
      gtmBasicEvent(eventData);

      registerForResource({
        resourceId,
        resourceType,
        registrationUrl,
      });
    }
  }, [lesson, isSingleLessonCourse, loggedIn, resourceType]);
}; 
